import React from 'react'
import { Grid, Typography } from "@mui/material"

const Version = () => {
    return (
        <Grid
            container justifyContent='center' alignItems='center' sx={{ height: '30vh' }} padding={5}>
            <Grid item>
                <Typography variant='h4' sx={{ color: '#fff' }}>Version - 0.0.2</Typography>
            </Grid>
            <Grid item >
                <Typography variant='h6'  sx={{ color: '#fff' }}>0.0.1 nominee and userProfileModification fetature release</Typography>

            </Grid>
        </Grid>
    )
}

export default Version